import React from "react";
// forcing rebuild
import ReactDataTable from "./ReactDataTable";
import { ApprovalEmployeeList } from "./ipmsmodel";
import { useManageIPMSContext } from "./ManageIPMSContex";
import { useNavigate } from "react-router-dom";
import moment from "moment";

const AppriserEmployeeListPage: React.FC = () => {
  const navigate = useNavigate();
  const { listAppriserEmployee, getAppriserEmployeeList } = useManageIPMSContext();

  const columns = [
    {
      name: "Employee Name",
      selector: (row: ApprovalEmployeeList) => (
        <span className=" text-wrap pl-10 block">{row.employee_name}</span>
      ),
      sortable: true,
      width: "240px",
    },
    {
      name: "Employee Id",
      selector: (row: ApprovalEmployeeList) => row.employeeid,
      sortable: true,
      center: true,
      width: "150px",
    },
    {
      name: "Department",
      selector: (row: ApprovalEmployeeList) => (
        <span className=" text-wrap pl-20 block">{row.department}</span>
      ),
      sortable: true,
      grow: 1,
    },
    {
      name: "DOJ",
      selector: (row: ApprovalEmployeeList) =>  row.dojs,
      sortable: true,
      center: true,
      width: "150px",
    },
    {
      name: "Designation",
      selector: (row: ApprovalEmployeeList) => (
        <span className=" text-wrap pl-20 block">{row.designation}</span>
      ),
      sortable: true,
      grow: 1,
    },
  ];

  React.useEffect(() => {
    // getAllDepartment({ skip: 0, limit: 50 });
    getAppriserEmployeeList({
      searchname: "",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleEdit = (row: ApprovalEmployeeList) => {
    if (row) {
      navigate(`/ipms_new/employees_list/assign_manager`, { state: { item: row } });
    }
  };


  return (
    <div>
  
      <ReactDataTable
        columns={columns}
        data={listAppriserEmployee?.map((item) => ({ ...item, dojs: item.doj ? moment(item.doj).format("DD/MM/YYYY") : ""})) ?? []}
        onEdit={handleEdit}
        dateOfJoinAction={"doj"}
        excelSheetHeader={[ "Employee Id","Employee Name",  "DOJ","Department", "Designation"]}
        showExport={listAppriserEmployee ? true : false}
        ReportName="Employee List"
        showFilter={listAppriserEmployee ? true : false}
      />
    </div>
  );
};

export default AppriserEmployeeListPage;
